import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import ActivityCategory from '../../entities/activityCategory';
import ActivityType from '../../entities/activityType';
export function deleteActivityCategory(activityCategory: ActivityCategory, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = activityCategory.id;}
const _work = workingSet();
store.getState().activityTypes.getMappingFor('activityCategoryId', activityCategory.id).filter(activityTypeTemp => activityTypeTemp.status !== 'D').forEach(activityTypeTemp => {
const _activityType = ((_work.get('activityType:' + activityTypeTemp.id) ?? activityTypeTemp) as ActivityType).clone();
_activityType.status = 'U';
_activityType.addedOn = newHRTimestamp();
_activityType.addedBy = getCurrentUserId();
_activityType.importSource = targetImportSource;
_activityType.importId = mergeId;
if (_activityType.activityCategoryId === activityCategory.id) {
_activityType.activityCategoryId = null;

}
_work.set('activityType:' + _activityType.id, _activityType);
store.dispatch(Actions.ActivityTypeActions.saveActivityTypeQueue(_activityType));
});



activityCategory.status = 'D';
activityCategory.addedOn = newHRTimestamp();
activityCategory.addedBy = getCurrentUserId();
activityCategory.importSource = targetImportSource;
activityCategory.importId = mergeId;
store.dispatch(Actions.ActivityCategoryActions.removeActivityCategoryQueue(activityCategory));
}
export function replaceActivityCategory(activityCategory: ActivityCategory, replaceWith: ActivityCategory, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = activityCategory.id;}
const _work = workingSet();
store.getState().activityTypes.getMappingFor('activityCategoryId', activityCategory.id).filter(activityTypeTemp => activityTypeTemp.status !== 'D').forEach(activityTypeTemp => {
const _activityType = ((_work.get('activityType:' + activityTypeTemp.id) ?? activityTypeTemp) as ActivityType).clone();
_activityType.status = 'U';
_activityType.addedOn = newHRTimestamp();
_activityType.addedBy = getCurrentUserId();
_activityType.importSource = targetImportSource;
_activityType.importId = mergeId;
if (_activityType.activityCategoryId === activityCategory.id) {
_activityType.activityCategoryId = replaceWith.id;

}
_work.set('activityType:' + _activityType.id, _activityType);
store.dispatch(Actions.ActivityTypeActions.saveActivityTypeQueue(_activityType));
});



return activityCategory;
}
export function deleteImpactActivityCategory(activityCategory: ActivityCategory) {
const impacts: string[] = [];
const state = store.getState();
const activityTypeActivityCategoryIdImpact = state.activityTypes.getMappingFor('activityCategoryId', activityCategory.id).filter(activityType => activityType.status !== 'D');
activityTypeActivityCategoryIdImpact.forEach(() => impacts.push('activityTypes'));



return util.countDistinct(impacts);
}
